<template>
  <div>
    <div class="imgOne">
      <img
        @mouseover="changeInterval(true)"
        @mouseleave="changeInterval(false)"
        v-for="(item, index) in banner_pic"
        :key="index"
        :src="item.thumb"
        alt="暂无图片"
        v-show="index === currentIndex"
        @click="LinksItem(item)"
      />
    </div>
    <div class="homeCont">
      <div class="contLeft">
        <div class="swiper">
          <slider
            ref="slider"
            :options="options"
            @slide="slide"
            @tap="onTap"
            @init="onInit"
          >
            <slideritem
              v-for="(item, index) in swiperList"
              :key="index"
              :style="item.style"
              v-html="item.html"
              @click.native="LinksItem(item)"
            ></slideritem>

            <!-- <div v-for="(item, index) in news_left_pic" :key="index">
              <img :src="item.thumb" alt="" />
            </div> -->
          </slider>

          <!-- <div
            class="SliderContainer"
            ref="slider"
            @touchstart="touchStart"
            @touchend="touchEnd"
            @touchmove="touchMove"
          >
            <div class="sliderGroup" ref="sliderGroup">
              <div class="slider" v-for="item in banner_pic" :key="item.id">
                <img :src="item.thumb" />
              </div>
            </div>
          </div> -->

          <div class="swiperTitle">
            <div class="title">{{ swiperList[swiperIndex].title }}</div>
            <div class="swiperDian">
              <div
                v-for="(item, index) in swiperList"
                :key="index"
                :class="index == swiperIndex ? 'dianActive' : ''"
              ></div>
            </div>
          </div>
        </div>
        <div class="laboratory">
          <img src="@/assets/img/laboratoryLogo.png" alt="" class="logo" />
          <div
            v-for="(item, index) in laboratoryList"
            :key="index"
            class="laboratoryItem"
            @click="LinksItem(item)"
          >
            <img :src="item.thumb" alt="" />
          </div>
        </div>
        <div class="recruit">
          <div class="recruitOne">
            <img src="@/assets/img/recruit.png" alt="" />
            <div class="MORE" @click="MORE(4)">MORE></div>
          </div>
          <div
            v-for="(item, index) in recruit"
            :key="index"
            class="recruitTwo"
            @click="articleDetails(4, item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="contMiddle">
        <div class="middleOne">
          <div class="middleTip">
            <img src="@/assets/img/news.png" alt="" />
            <div class="MORE" @click="MORE(1)">MORE></div>
          </div>
          <div
            class="newsItem"
            v-for="(item, index) in news"
            :key="index"
            @click="articleDetails(1, item)"
          >
            <div class="itemOne">
              <div class="newsOne">
                <div class="newsDian"></div>
                <div class="newsTitle">{{ item.title }}</div>
              </div>
              <div class="newsTime">{{ item.inputtime }}</div>
            </div>
            <div class="xuxian"></div>
          </div>
        </div>

        <div class="middleOne">
          <div class="middleTip">
            <img src="@/assets/img/notice.png" alt="" />
            <div class="MORE" @click="MORE(2)">MORE></div>
          </div>
          <div
            class="newsItem"
            v-for="(item, index) in notice"
            :key="index"
            @click="articleDetails(2, item)"
          >
            <div class="itemOne">
              <div class="newsOne">
                <div class="newsDian"></div>
                <div class="newsTitle">{{ item.title }}</div>
              </div>
              <div class="newsTime">{{ item.inputtime }}</div>
            </div>
            <div class="xuxian"></div>
          </div>
        </div>

        <div class="middleOne">
          <div class="middleTip">
            <img src="@/assets/img/information.png" alt="" />
            <div class="MORE" @click="MORE(3)">MORE></div>
          </div>
          <div
            class="newsItem"
            v-for="(item, index) in science"
            :key="index"
            @click="articleDetails(3, item)"
          >
            <div class="itemOne">
              <div class="newsOne">
                <div class="newsDian"></div>
                <div class="newsTitle">{{ item.title }}</div>
              </div>
              <div class="newsTime">{{ item.inputtime }}</div>
            </div>
            <div class="xuxian"></div>
          </div>
        </div>
      </div>
      <div class="contRight">
        <div class="rightOne">
          <div @click="allianceUniversities">
            <img src="@/assets/img/shixunke.png" alt="" />
            <div>吉林省环境实习实训课程共建网</div>
          </div>
        </div>
        <div class="rightOne rightTwo">
          <div @click="researchInstitute">
            <img src="@/assets/img/yanjiuyuan.png" alt="" />
            <div>东北地区低碳研究院</div>
          </div>
        </div>

        <div class="rightThree">
          <div class="threeTip">
            <span>关注我们 </span>
            <span>了解更多</span>
          </div>
          <div class="QRcode">
            <img :src="QRcode" alt="" />
          </div>
        </div>

        <div class="rightFour">
          <div class="fourTip">友情链接</div>
          <div
            v-for="(item, index) in LinksList"
            :key="index"
            class="linksItem"
            @click="LinksItem(item)"
          >
            {{ item.name }}
            <div
              :class="
                index == LinksList.length - 1 ? 'xuxian xuxianTwo' : 'xuxian'
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// rotationMap
/**
 * Created by www.xingnuocn.com
 * @title：首页
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-03-14 10:53
 */
import { slider, slideritem } from "vue-concise-slider"; // import slider components
export default {
  components: {
    slider,
    slideritem,
  },
  data() {
    return {
      news_left_pic: [],
      swiperList: [],
      swiperIndex: 0,
      howLong: 0,
      options: {
        currentPage: 0, // 当前页码
        autoplay: 3000,
        loop: true,
        pagination: false, // 底部小圆点是否隐藏（true显示，false隐藏）
        infinite: 1, // 无限滚动前后遍历数
        freeze: true,
      },

      laboratoryList: [], // 实验室大事记

      recruit: [], // 招贤纳士

      news: [], // 新闻动态

      notice: [], // 通知公告

      science: [], // 科技资讯

      LinksList: [], // 友情链接

      banner_pic: [], // 轮播图大图
      currentIndex: 0, //当前所在图片下标
      timer: null, //定时轮询

      QRcode: "", // 关于我们图片

      // aaa: '<table border=\'1\' style=\'border-collapse: collapse;\'><tbody><tr class="firstRow"><td width="39" valign="top" style="word-break: break-all; border: 1rpx solid #000000;">ddddd</td><td width="39" valign="top" style="word-break: break-all; border: 1rpx solid #000000;">ddddddd</td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td></tr><tr><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td><td width="39" valign="top"><br/></td></tr></tbody></table><p><br/></p>',

      timeOutEvent: 0,
      longClick: 0,
    };
  },
  mounted() {
    this.startInterval();

    this.getPicList();

    this.getArticleList();

    this.friendlyLink();

    this.siteFootInfoAndQrcode();
  },
  methods: {
    //  获取首页图片
    getPicList() {
      let that = this;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Index/getPicList`,
        data: {},
      }).then((result) => {
        // console.log("首页图片", result.data);
        if (result.data.code == 1) {
          that.banner_pic = result.data.data.banner_pic;
          that.news_left_pic = result.data.data.news_left_pic;

          for (let a in result.data.data.news_left_pic) {
            that.swiperList = that.swiperList.concat({
              html: `<img src="${result.data.data.news_left_pic[a].thumb}" style='width: 100%;height: 100%;' />`,
              title: result.data.data.news_left_pic[a].title,
              url:result.data.data.news_left_pic[a].url,
              style: {},
            });
          }

          that.laboratoryList = result.data.data.laboratory_pic;
        }
      });
    },

    //  获取首页文章列表
    getArticleList() {
      let that = this;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Index/getArticleList`,
        data: {},
      }).then((result) => {
        // console.log("首页文章", result.data);
        if (result.data.code == 1) {
          that.news = result.data.data.news; // 新闻动态
          that.notice = result.data.data.notice; // 通知公告
          that.science = result.data.data.science; // 科技资讯
          that.recruit = result.data.data.recruit; // 招贤纳士
        }
      });
    },

    // 友情链接
    friendlyLink() {
      let that = this;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Common/friendlyLink`,
        data: {},
      }).then((result) => {
        // console.log("友情链接", result.data);
        if (result.data.code == 1) {
          that.LinksList = result.data.data; // 友情链接
        }
      });
    },

    // 友情链接跳转
    LinksItem(item) {
      if (item.url != "") {
        window.open(item.url);
      }
    },

    // 关于我们。底部信息
    siteFootInfoAndQrcode() {
      let that = this;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Common/siteFootInfoAndQrcode`,
        data: {},
      }).then((result) => {
        // console.log("关于我们", result.data);
        if (result.data.code == 1) {
          for (let i in result.data.data) {
            that.QRcode = result.data.data[i].web_site_about_qrcode;
          }
        }
      });
    },

    //开启定时器
    startInterval() {
      // 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.currentIndex++;
        if (this.currentIndex > this.banner_pic.length - 1) {
          this.currentIndex = 0;
        }
      }, 3000);
    },

    //鼠标移入移出控制
    changeInterval(val) {
      if (val) {
        clearInterval(this.timer);
      } else {
        this.startInterval();
      }
    },

    // 轮播图切换 刘嘉鑫  2022-3-14
    slide(data) {
      this.swiperIndex = data.currentPage;
    },
    onTap(data) {
      console.log(data);
    },
    onInit(data) {
      // console.log(data);
    },

    // 吉林省环境类实习实训课
    allianceUniversities() {
      this.$router.push({ path: "/allianceUniversities" });
    },

    // 东北地区低碳研究院
    researchInstitute() {
      this.$router.push({ path: "/researchInstitute" });
    },

    //  1:新闻动态  2:通知公告  3:科技资讯  4:招贤纳士
    MORE(type) {
      this.$router.push({
        path: `/moreArticles`,
        query: { type: type, isDetails: 1 },
      });
    },

    // 文章列表详情
    articleDetails(type, item) {
      this.$router.push({
        path: `/moreArticles`,
        query: { type: type, isDetails: 2, article_id: item.article_id },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.imgOne {
  width: 100%;
  height: 204px;
  margin-bottom: 16px;
  img {
    width: 100%;
    height: 100%;
  }
}

.MORE {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #069ae6;
  cursor: pointer;
}

.xuxian {
  margin-top: 12px;
  width: 100%;
  height: 1px;
  background-image: linear-gradient(
    to right,
    #dddddd 0%,
    #dddddd 50%,
    transparent 50%
  );
  background-size: 16px 1px;
  background-repeat: repeat-x;
}

.xuxianTwo {
  margin-top: 12px;
  background-image: none !important;
}

.homeCont {
  display: flex;
  justify-content: space-between;
  .contLeft {
    width: 21%;
    // background: #234567;
    .swiper {
      width: 100%;
      height: 260px;
      position: relative;
      border-radius: 4px;
      margin-bottom: 29px;
      .slider-item {
        height: 260px;
        border-radius: 4px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .swiperTitle {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 10px;
        border-radius: 0px 0px 4px 4px;
        z-index: 1;
        .title {
          width: 80%;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .swiperDian {
          display: flex;
          align-items: center;

          > div {
            width: 8px;
            height: 8px;
            background: #ffffff;
            opacity: 0.4;
            border-radius: 50%;
            margin-left: 4px;
          }

          .dianActive {
            background: #069ae6;
          }
        }
      }
    }

    .laboratory {
      margin-bottom: 20px;
      .logo {
        width: 208px;
        height: 39px;
        margin-bottom: 19px;
      }
      .laboratoryItem {
        width: 100%;
        height: 60px;
        margin-bottom: 10px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .recruit {
      .recruitOne {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 17px;
        > img {
          width: 167px;
          height: 39px;
        }
      }
      .recruitTwo {
        padding: 9px 10px 12px;
        background: #f2f2f2;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #222222;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 10px;
        cursor: pointer;
      }
    }
  }
  .contMiddle {
    width: 56%;
    // background: #765432;
    .middleOne {
      width: 100%;
      margin-bottom: 30px;
      .middleTip {
        padding: 8px 10px;
        background: linear-gradient(
          90deg,
          rgba(4, 91, 167, 0.16) 0%,
          rgba(4, 91, 167, 0.04) 100%
        );
        display: flex;
        align-items: center;
        justify-content: space-between;
        > img {
          width: 99px;
          height: 20px;
        }
      }
      .newsItem {
        .itemOne {
          padding: 11px 8px 0px 11px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          .newsOne {
            display: flex;
            align-items: center;
            width: 80%;
            .newsDian {
              width: 6px;
              height: 6px;
              background: #045ba7;
              border-radius: 50%;
              margin-right: 12px;
            }
            .newsTitle {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #222222;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .newsTime {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #aaaaaa;
          }
        }
      }
    }
  }
  .contRight {
    width: 21%;
    .rightOne {
      margin-bottom: 30px;
      padding: 0 0 4px;
      background: #045ba7;
      border-radius: 4px;
      cursor: pointer;
      > div {
        padding: 23px 0;
        display: flex;
        align-content: center;
        justify-content: center;
        background: #e2f1ff;
        border-radius: 4px;
        width: 100%;
        > img {
          width: 54px;
          height: 54px;
          border-radius: 4px;
          margin-right: 19px;
        }
        > div {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #045ba7;
          width: 52%;
          line-height: 24px;
          margin-top: 4px;
        }
      }
    }
    .rightTwo {
      background: #069ae6;
      > div {
        background: #e4f6ff;
        > div {
          color: #069ae6;
        }
      }
    }

    .rightThree {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 30px;
      .threeTip {
        margin-bottom: 22px;
        > span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #045ba7;
        }
        > span:nth-child(2) {
          color: #999999;
        }
      }
      .QRcode {
        width: 160px;
        height: 160px;
        background: #f2f2f2;
        border-radius: 4px;
        padding: 19px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .rightFour {
      text-align: center;
      .fourTip {
        display: inline-block;
        padding: 11px 53px;
        background: #e4eef6;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #045ba7;
      }
      .linksItem {
        background: #f2f2f2;
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        padding: 19px 0 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }
}
</style>
